<template>
  <div class="container mt-4 mb-4">
    <FloatingCartBox
      v-if="currentProject && currentProject.id && cartSettings.cart_enabled"
      :currentProject="currentProject"
      :totalIncentive="totalIncentive"
      :pageConfiguration="pageConfiguration"
    />
    <div class="row">
      <div class="col-12">
        <div :class="['card', { 'no-card': disableCard }]">
          <div :class="['card-body', { 'no-card': disableCard }]">
            <span class="egx-partner-color">
              <h1 class="">{{ header.title }}</h1>
            </span>
            <div v-html="header.description" />
            <Step :content="currentStepContent" :step="step" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Step from './Step.vue';
import Dialog from '@/components/Dialog.vue';
import FloatingCartBox from '@/components/FloatingCartBox.vue';
import mockData from '../mockData';

export default {
  components: {
    Step,
    Dialog,
    FloatingCartBox,
  },
  props: {
    stepNum: Number
  },
  data() {
    return {
      header: mockData.header,
      stepContent: mockData.stepContent,
      disableCard: true,
      step: this.stepNum,
      showModal: false,
      cartItems: [],
      totalIncentive: null,
      pageConfiguration: {},
    };
  },

  created() {
    this.$store.dispatch('buildings/getAll');
    this.$store.dispatch('fulfill_integrate/getPageConfiguration', {
      task_name: 'measurecart',
      project_id: this.$route.params.id,
    })
    .then((response) => {
      console.log(response);
      this.pageConfiguration = response;
    })
    .catch((error) => {
      console.log(error);
    })
  },

  computed: {
    currentStepContent() {
      return this.stepContent[this.step - 1];
    },
    currentProject() {
      return this.$store.state.fulfill_integrate.project
    },
    cartSettings() {
      return this.$store.state.partners.currentPartner.settings.fulfill_sync_details.settings.project_measures_cart || {};
    },
  },
  watch: {
    '$route.query.step': {
      immediate: true,
      handler(newStep) {
        this.step = parseInt(newStep);
      }
    }
  },
}
</script>

<style scoped>
.no-card {
  border: none;
  box-shadow: none;
  padding: 0;
  margin: 0;
}
</style>
